<template>
  <v-container class="pa-6">
    <!-- Search & Filters -->
    <v-card outlined class="modern-card pa-6 mb-6">
      <v-row dense align="center">
        <v-col cols="12" md="5">
          <v-select
            v-model="family"
            :items="families"
            item-text="name"
            item-value="id"
            label="Filtrar por Familia"
            placeholder="Todas las Familias"
            outlined
            dense
            clearable
            hide-details
            prepend-inner-icon="fas fa-filter"
            class="modern-select"
          />
        </v-col>
        <v-col cols="12" md="7">
          <v-text-field
            v-model="search"
            @keyup="searchTimeOut"
            label="Búsqueda rápida"
            placeholder="Ingrese código o nombre del artículo..."
            prepend-inner-icon="fas fa-search"
            outlined
            dense
            hide-details
            clearable
            :disabled="loading"
            class="modern-search-field"
          />
        </v-col>
      </v-row>
    </v-card>

    <!-- Results Table -->
    <v-card outlined class="modern-card elevation-0 overflow-hidden">
      <v-data-table
        :headers="headers"
        :items="articles"
        :items-per-page="10"
        :loading="loading"
        :options.sync="options"
        :server-items-length="total"
        class="modern-table"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageOptions: [10, 20, 50],
        }"
      >
        <template v-slot:item.sku="{ item }">
          <v-chip x-small label color="primary" class="font-weight-black">{{item.sku}}</v-chip>
        </template>

        <template v-slot:item.name="{ item }">
          <span class="body-2 font-weight-black grey--text text--darken-3">{{item.name}}</span>
        </template>

        <template v-slot:item.family_name="{ item }">
           <span class="caption grey--text font-weight-medium">{{ item.family_name || 'N/A' }}</span>
        </template>

        <template v-slot:item.unit_name="{ item }">
           <v-chip x-small outlined label color="grey darken-1" class="font-weight-bold uppercase">{{ item.unit_name }}</v-chip>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn icon color="success" class="grey lighten-4 shadow-xs" small @click.stop="add(item)">
            <v-icon x-small>fas fa-plus</v-icon>
          </v-btn>
        </template>

        <template v-slot:no-data>
           <div class="pa-12 text-center grey--text lighten-2">
            <v-icon x-large class="mb-4 opacity-20">fas fa-boxes-stacked</v-icon>
            <div class="text-subtitle-1 font-weight-bold grey--text">No se encontraron artículos</div>
            <div class="caption grey--text opacity-70 mt-1">Intente ajustar los filtros de búsqueda.</div>
          </div>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { fetchArticles, fetchFamilies, fetchUnits } from '@/api/stocks'
import notifications from '@/utils/notifications'

export default {
  name: 'ArticlesTable',
  props: ['value'],
  data() {
    return {
      loading: false,
      family: '',
      families: [],
      units: [],
      articles: [],
      article: '',
      timer: '',
      options: {},
      search: '',
      total: 0,
      headers: [
        { text: 'Código', align: 'start', value: 'sku', class: 'grey lighten-5 font-weight-black', width: '150' },
        { text: 'Nombre', align: 'start', value: 'name', class: 'grey lighten-5' },
        { text: 'Familia', align: 'start', value: 'family_name', class: 'grey lighten-5', width: '200' },
        { text: 'Unidad', align: 'start', value: 'unit_name', class: 'grey lighten-5', width: '120' },
        { text: '', value: 'actions', class: 'grey lighten-5', align: 'center', sortable: false, width: '80' }
      ],
    }
  },
  methods: {
    async fetch() {
      if (!this.options || !this.options.page) return
      this.loading = true
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      let sort = ''
      if (sortBy && sortBy[0] == 'family_name') sort = 'family__name'
      else if (sortBy && sortBy[0] == 'unit_name') sort = 'unit__name'
      else sort = sortBy && sortBy[0] ? sortBy[0] : 'sku'

      if (!this.family) this.family = ''
      const ordering = sortDesc && sortDesc[0] ? sort : `-${sort}`
      const query = `ordering=${ordering}&page=${page}&page_size=${itemsPerPage}&search=${this.search}&family=${this.family}&status=true`
      
      try {
        const res = await fetchArticles(query)
        this.total = res.count
        this.articles = res.results
      } catch (err) {
        notifications.showError('Error cargando artículos ' + err)
      } finally {
        this.loading = false
      }
    },
    searchTimeOut() {
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => { this.fetch() }, 800)
    },
    add(item) {
      this.$emit('input', item)
    }
  },
  watch: {
    family() {
      if (this.options && this.options.page) this.options.page = 1
      this.fetch()
    },
    options: {
      handler: 'fetch',
      deep: true
    }
  },
  async mounted() {
    this.families = await fetchFamilies()
    this.units = await fetchUnits()
  }
}
</script>

<style scoped>
.modern-card {
  border: 1px solid rgba(0,0,0,0.08) !important;
  border-radius: 12px !important;
}
.modern-table {
  background: transparent !important;
}
.modern-table >>> thead th {
  font-size: 0.75rem !important;
  font-weight: 800 !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  height: 48px !important;
}
.shadow-xs {
  box-shadow: 0 1px 2px rgba(0,0,0,0.05) !important;
}
.opacity-20 { opacity: 0.2; }
.opacity-70 { opacity: 0.7; }
.uppercase { text-transform: uppercase; }
</style>